<template>
  <div class="page">
    <TopNav
        activeLv1="changePassword"
        activeLv2=""
        @nav="onNav"
        @sub="onSub"
    />

    <div class="wrap">
      <h3>{{$t('Changepassword.Changeyourpassword')}}</h3>

      <table class="form">
        <tr>
          <td>{{$t('Changepassword.OldPassword')}}</td>
          <td>
            <input type="password" v-model="oldPassword" />
          </td>
        </tr>

        <tr>
          <td>{{$t('Changepassword.NewPassword')}}</td>
          <td>
            <input type="password" v-model="newPassword" />
          </td>
        </tr>

        <tr>
          <td>{{$t('Changepassword.ConfirmPassword')}}</td>
          <td>
            <input type="password" v-model="confirmPassword" />
          </td>
        </tr>

        <tr>
          <td></td>
          <td>
            <div class="btn-row">
              <button @click="submit">{{$t('Changepassword.Confirm')}}</button>
              <button @click="clear">{{$t('Changepassword.Clear')}}</button>
            </div>
          </td>
        </tr>
      </table>

      <div class="note">
        <b>{{$t('Changepassword.Note')}}:</b>
        <ol>
          <li>{{$t('Changepassword.Note1')}}</li>
          <li>{{$t('Changepassword.Note2')}}</li>
          <li>{{$t('Changepassword.Note3')}}</li>
        </ol>
      </div>
    </div>
  </div>
</template>
<script>
import TopNav from "@/components/TopNav.vue";
import http from "@/api/http";

export default {
  components: { TopNav },

  data() {
    return {
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    };
  },

  methods: {
    onNav(key) {
      if (key === "news") {
        this.$router.push("/lotto");
        return;
      }
      if (key === "lotto") {
        this.$router.push("/lotto");
        return;
      }
      if (key === "lottery") {
        this.$router.push("/lottery");
        return;
      }
      if (key === "report") {
        this.$router.push("/report");
        return;
      }
      if (key === "balance") {
        this.$router.push("/balance");
        return;
      }
      if (key === "changePassword") {
        this.$router.push("/change-password");
        return;
      }
      alert("Coming soon");
    },
    onSub() {},

    async submit() {
      if (!this.oldPassword || !this.newPassword || !this.confirmPassword) {
        alert("Please fill all fields");
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        alert("Confirm password does not match");
        return;
      }
      if (this.newPassword.length < 6) {
        alert("Password length must be at least 6");
        return;
      }
      if (!/(?=.*[A-Za-z])(?=.*\d)/.test(this.newPassword)) {
        alert("Password must contain letters and digits");
        return;
      }

      try {
        await http.post("/api/player/account/change-password", {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        });

        alert("Password changed successfully. Please login again.");
        this.$store.dispatch("auth/logout");
        this.$router.replace("/login");
      } catch (e) {
        alert(e?.response?.data?.message || "Change password failed");
      }
    },

    clear() {
      this.oldPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
    }
  }
};
</script>
<style scoped>
.page { background:#fff; min-height:100vh; min-width: 1280px; }
.wrap { 
  padding: 10px 0 0 10px;
  width: 450px;
  height: 244px;
  box-sizing: border-box;
}
h3 {
  width: 435px;
  height: 35px;
  margin: 0;
  display: flex;
  align-items: center;
  color: #27448C;
  font-size: 18px;
  font-weight: bold;
}
.form {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}
.form td { 
  padding: 2px 0;
  height: 25px;
  color: #000000;
  font-size: 13px;
}
.form td:first-child {
  width: 130px;
  text-align: right;
  padding-right: 15px;
}
input {
  width: 200px;
  height: 25px;
  padding: 0 5px;
  box-sizing: border-box;
  border: 1px solid #7F9DB9;
  outline: none;
}
.btn-row {
  display: flex;
  gap: 10px;
  margin-top: 5px;
}
button {
  width: 80px;
  height: 23px;
  background: #DFE8FF;
  border: 1px solid #7F9DB9;
  border-radius: 4px;
  color: #27448C;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
button:hover {
  background: #cfdcff;
}
.note {
  margin-top: 15px;
  font-size: 12px;
  color: #000000;
  line-height: 1.5;
}
.note b {
  display: block;
  margin-bottom: 5px;
}
.note ol {
  margin: 0;
  padding-left: 20px;
}
</style>
